import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

export const ListItemContainer = styled.div`
  display: grid;
  grid-template-columns: auto min-content;
  padding: 0.9375rem 1.25rem 0.9375rem 0;
  border-bottom: 0.0625rem solid ${color.SILVER};
  font-family: sidecarta-sans, sans-serif;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  grid-column-start: 1;
  grid-column-end: 2;

  & p {
    color: ${color.MORTAR};
  }
`

export const ValueContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  grid-column-start: 2;
  grid-column-end: 3;
  font-family: sidecarta-sans-bold, sans-serif;
  color: ${color.BLACK};
`
